export const timeMarkerIcon = 'https://cdn-icons-png.flaticon.com/512/1783/1783356.png';
export const startMarkerIcon = 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png';
export const endMarkerIcon = "http://maps.google.com/mapfiles/ms/icons/pink-dot.png";
export const currentMarkerIcon = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"